import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { ImagePicker } from "../utils/imagePicker";
import './PlayerPreview.scss';
import Footer from "./Footer";
import SubHeader from "./SubHeader";
import ScenarioUtils from "../utils/scenarioUtils";
import { PlayerStatusEnum } from "../types/playerStatusEnum";

export default function PlayerPreview(props: { playerPosition: number, onClose: () => void }) {
    const { playerName } = useSelector((state: RootState) => state.general);
    const { playerView, playerRole } = useSelector((state: RootState) => state.game);
    const player = playerView?.other_players_state[props.playerPosition];

    if(!player){
        return <div>Unknown player</div>
    }
    
    const playerStatus = ScenarioUtils.GetOtherPlayerStatus(playerName === player.name, playerRole, playerView?.is_dead === true, player.role_name, player.is_dead);
    const showClass = playerStatus !== PlayerStatusEnum.Hidden;
    const customClass = player.is_dead ? `char-name neutral dead` : showClass ? 'mark' : 'char-name';
    const className = (showClass) ? <span>{player.role_name}</span> : <></>


    return <div className="mafia-container-wrapper">
        <div className="mafia-container" onClick={() => props.onClose()}>
            <SubHeader>
                Player {player?.name}
            </SubHeader>
            <div className={`char-preview-img ${player?.is_dead ? 'smaller' : ''}`}>
                {player?.is_dead && <img src={ImagePicker.GetImage(props.playerPosition, true)} />}
                <img className={player?.is_dead ? 'dead' : ''} src={ImagePicker.GetImage(props.playerPosition, false)} />
            </div>
            <div className="char-status">
                <div className={customClass}>{className} {`${player.name}`}</div>
                <div className='dead'>{playerStatus === PlayerStatusEnum.Hidden ? 'Unknown role' : ''}</div>
                <div className={player.is_dead ? 'dead' : 'town'}>({player.is_dead ? 'DEAD' : 'ALIVE'})</div>
            </div>
        </div>
        <Footer>
            <button onClick={() => props.onClose()}>Back</button>
        </Footer>
    </div>
}